import React, { useMemo } from 'react';

import useFormattedName from '../../hooks/useFormattedName';

import scss from '../AiPlayground.module.scss';

function UserIcon() {
  const formattedName = useFormattedName();

  const mainWord = useMemo(() => formattedName[0]?.toUpperCase(), [formattedName]);

  return <div className={scss.userIcon}>{mainWord}</div>;
}

export default UserIcon;
